import { useEffect, useState } from "react";
import { Check, X } from "lucide-react";
import { api, fmtAZN } from "@/lib/api";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";

export const ReceiptViewer = ({ tx, onClose, onAct }) => {
  const [url, setUrl] = useState(null);
  const [err, setErr] = useState(false);

  useEffect(() => {
    if (!tx) return;
    let u;
    setUrl(null); setErr(false);
    api.get(`/admin/receipts/${tx.id}`, { responseType: "blob" })
      .then(({ data }) => { u = URL.createObjectURL(data); setUrl(u); })
      .catch(() => setErr(true));
    return () => u && URL.revokeObjectURL(u);
  }, [tx]);

  const pdf = tx?.receipt_type === "application/pdf";
  return (
    <Dialog open={!!tx} onOpenChange={(o) => !o && onClose()}>
      <DialogContent className="bg-[#111] border-[#D4AF37]/40 text-white max-w-2xl" data-testid="receipt-dialog">
        <DialogHeader><DialogTitle className="font-display">Qəbz · {tx?.user_email} · {fmtAZN(tx?.amount)}</DialogTitle></DialogHeader>
        <div className="rounded-xl bg-black/50 min-h-[300px] flex items-center justify-center overflow-hidden">
          {err ? <p className="text-red-400 text-sm">Qəbz yüklənmədi</p> : !url ? <p className="text-zinc-500 text-sm">Yüklənir...</p> : pdf ? (
            <iframe src={url} title="qəbz" className="w-full h-[60vh]" />
          ) : (
            <img src={url} alt="qəbz" className="max-h-[60vh] object-contain" data-testid="receipt-image" />
          )}
        </div>
        {url && <a href={url} target="_blank" rel="noreferrer" className="text-xs text-[#FFD700] hover:underline">Yeni pəncərədə aç</a>}
        {tx?.status === "pending" && (
          <div className="flex gap-3">
            <button onClick={() => onAct("approve")} className="flex-1 rounded-full py-3 bg-emerald-600 hover:bg-emerald-500 font-bold flex items-center justify-center gap-2" data-testid="receipt-approve-btn"><Check size={16} /> Təsdiq et</button>
            <button onClick={() => onAct("reject")} className="flex-1 rounded-full py-3 bg-red-600 hover:bg-red-500 font-bold flex items-center justify-center gap-2" data-testid="receipt-reject-btn"><X size={16} /> Ləğv et</button>
          </div>
        )}
      </DialogContent>
    </Dialog>
  );
};
